import { sessionService } from '@/providers/services/auth/session';
import { DEFAULT_IMAGES_PATH, TAXONOMY_LEVELS } from '@/utils/constants';
import { findAnyCompetencyTitle } from '@/utils/utils';
import { taxonomySerializer } from './taxonomy';

export class OfflineActivitySerializer {

    private static INSTANCE = new OfflineActivitySerializer();
    static get instance() {
        return this.INSTANCE;
    }

  /**
   * @function normalizeSearchOfflineActivities
   * Method to serialize search offline activities
   */
  public normalizeSearchOfflineActivities(payload: any) {
    const resultSet = {
        searchResults: [],
        hitCount: payload.totalHitCount,
      };
    if (Array.isArray(payload.searchResults)) {
        const results = payload.searchResults.map((result: any) => {
          return this.normalizeOfflieActivity(result);
        });
        resultSet.searchResults = results;
      }
    return resultSet;
  }

  /**
   * Normalize a offine activity
   * @param {*} offlineActivityData
   * @returns {offlineActivityData}
   */
  public normalizeOfflieActivity(offlineActivityData: any) {
    const serializer = this;
    const cdnUrls = sessionService.getCdnUrl();
    const basePath = cdnUrls.content_cdn_url;
    const userBasePath = cdnUrls.user_cdn_url;
    const appRootPath = window.location.origin; // configuration appRootPath
    const thumbnailUrl = offlineActivityData.thumbnail
      ? basePath + offlineActivityData.thumbnail
      : appRootPath + DEFAULT_IMAGES_PATH.offlineActivity;
    const userThumbnailUrl = offlineActivityData.userProfileImage
      ? userBasePath + offlineActivityData.userProfileImage
      : appRootPath + DEFAULT_IMAGES_PATH.profile;
    const creatorThumbnailUrl = offlineActivityData.creatorProfileImage
      ? userBasePath + offlineActivityData.creatorProfileImage
      : appRootPath + DEFAULT_IMAGES_PATH.profile;
    const taxonomyInfo =
      (offlineActivityData.taxonomySet &&
        offlineActivityData.taxonomySet.curriculum &&
        offlineActivityData.taxonomySet.curriculum.curriculumInfo) ||
      [];

    const course = offlineActivityData.course || {};
    const standards = taxonomySerializer.normalizeTaxonomyArray(taxonomyInfo, false);
    return {
      id: offlineActivityData.id,
      title: offlineActivityData.title,
      description: offlineActivityData.description || findAnyCompetencyTitle(standards),
      type: offlineActivityData.type ? offlineActivityData.type : offlineActivityData.format,
      thumbnailUrl,
      standards,
      publishStatus: offlineActivityData.publishStatus,
      learningObjectives: offlineActivityData.languageObjective || findAnyCompetencyTitle(standards),
      resourceCount: offlineActivityData.resourceCount || 0,
      questionCount: offlineActivityData.questionCount || 0,
      remixCount: offlineActivityData.scollectionRemixCount || 0,
      taskCount: offlineActivityData.taskCount || 0,
      course: course.title,
      courseId: course.id,
      isVisibleOnProfile: offlineActivityData.profileUserVisibility,
      owner: {
        id: offlineActivityData.gooruUId,
        firstName: offlineActivityData.userFirstName,
        lastName: offlineActivityData.userLastName,
        avatarUrl: userThumbnailUrl,
        username: offlineActivityData.usernameDisplay,
      },
      creator: {
        id: offlineActivityData.creatorId,
        firstName: offlineActivityData.creatorFirstname,
        lastName: offlineActivityData.creatorLastname,
        avatarUrl: creatorThumbnailUrl,
        username: offlineActivityData.creatornameDisplay,
      },
      taxonomySet: offlineActivityData.taxonomySet,
      createdDate: offlineActivityData.addDate,
      collaboratorIDs: offlineActivityData.collaboratorIds,
      grade: offlineActivityData.grade,
      instructionalModel: offlineActivityData.instructionalMethod,
      lastModified: offlineActivityData.lastModified,
      lastModifiedBy: offlineActivityData.lastModifiedBy,
      license: offlineActivityData.license,
      audience: offlineActivityData.audience,
      keyPoints: offlineActivityData.keyPoints,
      efficacy: offlineActivityData.efficacy ? offlineActivityData.efficacy : null,
      relevance: offlineActivityData.relevance ? offlineActivityData.relevance : null,
      engagement: offlineActivityData.engagement ? offlineActivityData.engagement : null,
      publisherQualityIndicator: offlineActivityData.publisherQualityIndicator,
    };
  }
}

export const offlineActivitySerializer = OfflineActivitySerializer.instance;
